<template>
  <div class="nuttrema-layout-form-standard" :class="[`theme-${theme}`]">
    <div v-if="checkSlot('header')" class="nuttrema-layout-form-standard__header">
      <slot name="header"></slot>
    </div>
    <transition name="top-slide" :duration="250" enter-active-class="animated is-speed slideInDown" leave-active-class="animated is-speed slideOutUp">
      <div v-if="error" class="nuttrema-layout-form-standard__error">

        <div class="error-message">
          <div class="error-message__content">
            <div class="error-message__content__title">
              {{ _get(error, 'error', $t('message.default_error_message')) }}
            </div>
            <div class="error-message__content__text" v-if="_has(error, 'details.errors')">
              <p v-for="error in error.details.errors">{{ error.message }}</p>
            </div>
            <div class="error-message__content__text" v-else-if="!_isEmpty(error.message)">
              <p>{{ error.message }}</p>
            </div>
          </div>
        </div>

        <button-resize-toggler
           class="is-top-side"
           theme="error"
          :collapsed="!error"
          :title="$t('label.clear_error_message')"
          @click="clearErrors">
        </button-resize-toggler>
      </div>
    </transition>
    <div v-if="checkSlot('center')" class="nuttrema-layout-form-standard__center">
      <slot name="center"></slot>
    </div>
    <div v-if="checkSlot('footer')" class="nuttrema-layout-form-standard__footer">
      <transition name="glide" :duration="250" enter-active-class="animated is-speed slideInUp" leave-active-class="animated is-speed slideOutDown">
        <div class="nuttrema-layout-form-standard__footer__content" v-show="edit">
          <slot name="footer"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { has, cloneDeep } from 'lodash';
import ButtonResizeToggler from 'components/ui/button/button-resize-toggler';

export default {
  name: 'nuttrema-layout-form-standard',
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    toggleModeWidth: {
      type: String,
      required: false,
      default: null,
    },
    saveError: {
      required: false,
      default: null,
    },
    theme: {
      required: false,
      default: 'default',
    },
  },
  components: {
    ButtonResizeToggler,
  },
  data() {
    return {
      error: null,
      elementWidth: null,
      elementHeight: null,
    };
  },
  methods: {
    checkSlot(slot) {
      return has(this.$slots, slot) && this.$slots[slot][0].tag !== undefined;
    },
    // getElementWidth() {
    //   this.elementWidth = this.$el.offsetWidth;
    // },
    // getElementHeight() {
    //   this.elementHeight = this.$el.offsetHeight;
    // },
    clearErrors() {
      this.error = null;
    },
  },
  watch: {
    saveError(newValue) {
      this.error = cloneDeep(newValue);
    },
  },
  created() {
    this.error = cloneDeep(this.saveError);
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     window.addEventListener('resize', this.getElementWidth);
  //     window.addEventListener('resize', this.getElementHeight);
  //     // Init
  //     this.getElementWidth();
  //     this.getElementHeight();
  //   });
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.getElementWidth);
  //   window.removeEventListener('resize', this.getElementHeight);
  // },
};
</script>

<style lang="scss" scoped src="./nuttrema-layout-form-standard.scss"></style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-form-standard.vue